
/*
 Copyright (c) 2012, Yahoo! Inc.  All rights reserved.
 Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var Store = require('./store'),
    Report = require('./report'),
    Command = require('./command');

Store.loadAll();
Report.loadAll();
Command.loadAll();






//////////////////
// WEBPACK FOOTER
// ./~/istanbul/lib/register-plugins.js
// module id = 793
// module chunks = 0